/* gb-partner.js: tiny vanilla JS for the DundasPrint x Growth Boss partner page (variant A).
   1) scroll reveals (the page is fully visible if this file never runs)
   2) copy-code button with a visible state and a fallback when the clipboard is blocked
   3) keep our growthboss.co links in the same tab (the theme script adds target=_blank to every external link) */
(function () {
  'use strict';

  var root = document.getElementById('gbp');
  if (!root) return;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- 1. reveals ---------- */
  function initReveals() {
    var groups = Array.prototype.slice.call(root.querySelectorAll('.gbp-rv'));
    if (!groups.length || reduceMotion || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gbp-is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    groups.forEach(function (group) {
      var rect = group.getBoundingClientRect();
      var inView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
      if (inView) return; /* already on screen: leave it visible, no flash */
      group.classList.add('gbp-is-armed');
      io.observe(group);
    });
  }

  /* ---------- 2. copy code ---------- */
  function initCopy() {
    var btn = root.querySelector('[data-gbp-copy]');
    if (!btn) return;

    var code = btn.getAttribute('data-gbp-copy') || '';
    var label = btn.querySelector('[data-gbp-copy-label]');
    var icon = btn.querySelector('use');
    var live = root.querySelector('[data-gbp-live]');
    var codeEl = root.querySelector('[data-gbp-code]');
    var timer = 0;

    /* the button only exists for people whose browser runs this script */
    btn.hidden = false;

    function setState(state) {
      window.clearTimeout(timer);
      if (state === 'idle') {
        btn.removeAttribute('data-state');
        if (label) label.textContent = 'Copy';
        if (icon) icon.setAttribute('href', '#gbp-i-copy');
        if (live) live.textContent = '';
        return;
      }
      btn.setAttribute('data-state', state);
      if (state === 'copied') {
        if (label) label.textContent = 'Copied';
        if (icon) icon.setAttribute('href', '#gbp-i-check');
        if (live) live.textContent = code + ' copied to your clipboard';
      } else {
        if (label) label.textContent = 'Selected';
        if (icon) icon.setAttribute('href', '#gbp-i-copy');
        if (live) live.textContent = code + ' is selected. Press Control or Command plus C to copy it.';
      }
      timer = window.setTimeout(function () { setState('idle'); }, 2600);
    }

    function selectCode() {
      if (!codeEl || !window.getSelection || !document.createRange) return false;
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      return true;
    }

    /* old-school copy through a temporary textarea */
    function legacyCopy(text) {
      var prev = document.activeElement;
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, text.length);
        var ok = document.execCommand && document.execCommand('copy');
        document.body.removeChild(ta);
        if (prev && prev.focus) prev.focus();
        return !!ok;
      } catch (e) {
        if (prev && prev.focus) prev.focus();
        return false;
      }
    }

    function copy(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).then(
          function () { return true; },
          function () { return legacyCopy(text); }
        );
      }
      return Promise.resolve(legacyCopy(text));
    }

    btn.addEventListener('click', function () {
      copy(code).then(function (ok) {
        if (ok) {
          setState('copied');
        } else {
          /* last resort: highlight the code so the visitor can copy by hand */
          selectCode();
          setState('select');
        }
      });
    });
  }

  /* ---------- 3. same-tab links ----------
     theme.min.js marks every external link target=_blank and points aria-describedby at its
     "opens in a new window" note. The brief wants these buttons to open in the same tab, so we
     strip both attributes and keep stripping if the theme sets them again. */
  function initSameTab() {
    var links = root.querySelectorAll('a[href]');
    function clean(a) {
      if (a.hasAttribute('target')) a.removeAttribute('target');
      if (a.getAttribute('aria-describedby') === 'a11y-new-window-message') a.removeAttribute('aria-describedby');
    }
    Array.prototype.forEach.call(links, function (a) {
      clean(a);
      if ('MutationObserver' in window) {
        new MutationObserver(function () { clean(a); })
          .observe(a, { attributes: true, attributeFilter: ['target', 'aria-describedby'] });
      }
    });
  }

  initSameTab();
  initReveals();
  initCopy();
})();
